module.exports = __webpack_public_path__ + "img/route_8_s.ed1d0d38.png";